<template>
  <div class="widget-overlay">
    <img :src="`${baseUrl}assets/images/explore.gif`" />
    <div
      class="suggestion"
      v-html="formatSuggestion($ml.get('content').suggestion)"
    ></div>
    <button class="button-secondary" @click="click">
      {{ $ml.get("content").secondary_button }}
    </button>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "widget-overlay",
  methods: {
    click() {
      this.setwidgetViewed(true);

      if (this.$route.name === "landing") {
        this.setHomeInLanding(true);
      }
    },
    formatSuggestion(string) {
      return string.replace(".", ".<br>");
    },
    ...mapActions(["setwidgetViewed", "setHomeInLanding"])
  },

  data() {
    return {
      baseUrl: process.env.BASE_URL
    };
  }
};
</script>

<style lang="scss" scoped>
.widget-overlay {
  width: 100%;
  height: 100%;
  opacity: 0.7;
  background: darken(rgb(249, 227, 190), 80%);
  z-index: 1;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  user-select: none;
  backdrop-filter: blur(30px);
  img {
    width: 100px;
  }
  .suggestion {
    @include h4-mobile-center;
    margin: 21px 0;
  }
}
</style>
